// extracted by mini-css-extract-plugin
export var boxItems = "_22-1";
export var boxItemsLg = "_22-2";
export var button = "_22-7";
export var buttonLg = "_22-8";
export var filterGroupBox = "_22-0";
export var icon = "_22-3";
export var iconSecondary = "_22-6";
export var iconWrapper = "_22-4";
export var iconWrapperLg = "_22-5";